import theme from 'styled-theming'

export default (mode, styles) =>
  theme('mode', {
    [mode]: styles
  })
